import { render, staticRenderFns } from "./AddNewUserModal.vue?vue&type=template&id=60502137&"
import script from "./AddNewUserModal.vue?vue&type=script&lang=ts&"
export * from "./AddNewUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports